<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="12" class="d-md-flex">
        <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :setDates="true"
            :disabled="loaded"
        />
        <v-switch
            v-model="isCompareFilter"
            hide-details
            color="orange darken-3"
            class="mx-5 mt-md-1 my-3 mb-md-0"
        >
          <template #label>
            <span class="ml-1">Compare</span>
          </template>
        </v-switch>
        <CompareFilter
            v-if="isCompareFilter"
            :end="dateCompareEnd"
            :start="dateCompareStart"
            :periodStart="dateStart"
            :periodEnd="dateEnd"
            @getDates="getCompareDates"
            :bgColor="compareFilterColor"
            :filterIcon="compareIcon"
            :diffDays="diffDays"
            :disabled="loadedCompare"
        />
      </v-col>
    </v-row>
    <div class="d-flex flex-wrap mt-3 mt-sm-7">
      <v-card class="calls-card rounded-lg elevation-2 d-flex  mr-2 flex-column mb-7"
              :style="{'visibility': card.value === '' ? 'hidden' : ''}"
              :loading="loaded || loadedCompare" loader-height="1"
              v-for="card in cards"
              :key="card.value"
      >
        <v-card-title class="calls-card-title pa-0">{{ card.title }}</v-card-title>
        <v-card-text class="calls-text-card pa-0 mt-5">
          <div class="d-flex flex-column align-center justify-center">
            <div>
              <p>FlameHub User: <span v-if="!loaded && card.filter === 'formatPrice'">${{ data[card.value] | formatPrice }}</span>
              <span v-if="!loaded && card.filter === 'formatFloat'">
                <a v-if="card.type === 'link' && data[card.value] > 0" @click="redirectToSalesReport(card.value)" style="color: black; text-decoration: underline;">
                  {{ data[card.value] | formatFloat }}
                </a>
                <span v-else>{{ data[card.value] | formatFloat }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_cmp`] > 0 && isCompareFilter"
                  class="ml-1 align-self-center compare-text green--text text--darken-3">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
                <span class="ml-0">{{ dataCompare[`${card.value}_cmp`] | formatFloat }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_cmp`] < 0 && isCompareFilter"
                  class="ml-1 align-self-center compare-text red--text text--darken-3">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
                <span class="ml-0">{{ dataCompare[`${card.value}_cmp`] | formatFloatAbs }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_cmp`] == 0 && isCompareFilter"
                  class="compare-text blue--text text--darken-3">0
              </span>
              </p>
            </div>
            <div>
              <p>Copper Company <span v-if="card._copper">({{card._copper}})</span> : <span v-if="!loaded && card.filter === 'formatPrice'">${{ data[`${card.value}_copper`] | formatPrice }}</span>
              <span v-if="!loaded && card.filter === 'formatFloat'">
                <a v-if="card.type === 'link' && data[`${card.value}_copper`] > 0" @click="redirectToSalesReport(`${card.value}_copper`)" style="color: black; text-decoration: underline;">
                  {{ data[`${card.value}_copper`] | formatFloat }}
                </a>
                <span v-else>{{ data[`${card.value}_copper`] | formatFloat }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_copper_cmp`] > 0 && isCompareFilter"
                  class="ml-1 align-self-center compare-text green--text text--darken-3">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
                <span class="ml-0">{{ dataCompare[`${card.value}_copper_cmp`] | formatFloat }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_copper_cmp`] < 0 && isCompareFilter"
                  class="ml-1 align-self-center compare-text red--text text--darken-3">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
                <span class="ml-0">{{ dataCompare[`${card.value}_copper_cmp`] | formatFloatAbs }}</span>
              </span>
              <span v-if="dataCompare[`${card.value}_copper_cmp`] == 0 && isCompareFilter"
                  class="compare-text blue--text text--darken-3">0
              </span>
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pt-3">
        <v-col cols="6" class="pb-0">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="1" class="pb-0">
          <v-btn
                    color="#3F51B5"
                    dark
                    depressed
                    height='40'
                    max-width='40'
                    min-width='40'
                    @click="cleanFilters"
                >
                  <v-icon>
                    mdi-autorenew
                  </v-icon>
                </v-btn>
        </v-col>
        <v-col cols="2" class="pb-0">
          <v-autocomplete
            dense
            v-model="byOrderFilter"
            :items="['All', '= 1 Order', '> 1 Order']"
            :menu-props="{ maxHeight: '200' }"
            outlined
            @change="applyOrderFilters"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="3" >
          <v-switch
              v-model="isHubFilter"
              hide-details
              color="orange darken-3"
              class="mx-5 mt-md-1 my-3 mb-md-0"
              style="float: right"
          >
            <template #label>
              <span class="ml-1" v-if="isHubFilter === false">Copper</span>
              <span class="ml-1" v-else>FlameHub</span>
            </template>
          </v-switch>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg" v-if="isHubFilter">
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
                class="mx-2 scroll-btn btn-left"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
                class="mx-2 scroll-btn btn-right"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :headers="headers"
              :search="search"
              :items="dataItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="customer_name"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
              :loading="loaded"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
          >
            <template v-slot:no-data>
              <span>No data</span>
            </template>
            <template v-slot:top>

            </template>
            <template v-slot:item.txn_date="{ item }">
              <span>{{ item.txn_date | formatDate }}</span>
            </template>
            <template v-slot:item.total_amt="{ item }">
              <span>$ {{ item.total_amt | formatPrice }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg" v-else>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn
                class="mx-2 scroll-btn btn-left"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
                class="mx-2 scroll-btn btn-right"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :headers="headersCopper"
              :search="search"
              :items="dataItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="customer_name"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
              }"
              :loading="loaded"
              loading-text="Loading... Please wait"
              @click:row="rowClick"
          >
            <template v-slot:no-data>
              <span>No data</span>
            </template>
            <template v-slot:top>

            </template>
            <template v-slot:item.txn_date="{ item }">
              <span>{{ item.txn_date | formatDate }}</span>
            </template>
            <template v-slot:item.total_amt="{ item }">
              <span>$ {{ item.total_amt | formatPrice }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import moment from 'moment'
import RangeFilter from '@/components/filters/RangePicker'
import CompareFilter from '@/components/filters/ComparePicker'

export default {
  components: {
    RangeFilter,
    CompareFilter
  },
  data() {
    return {
      byOrderFilter: 'All',
      dataItems:[],
      isHubFilter: true,
      dateCompareEnd: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              0
          )).toISOString().substr(0, 10),
      dateCompareStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth() - 1,
              0
          )).toISOString().substr(0, 10),
      diffDays: 0,
      compareFilterColor: 'orange darken-3',
      defaultComparePeriod: 5,
      compareIcon: 'mdi-compare-vertical',
      isCompareFilter: false,
      search: '',
      hideAnything: false,
      selected: [],
      data: {},
      dataCompare: {},
      cards: [
        {title: 'Total Customers', value: 'totalCustomer', filter: 'formatFloat', _copper:'with N/A'},
        {title: 'New Customers', value: 'newCustomer', filter: 'formatFloat'},
        {title: 'Recurrent Customers', value: 'recurrentCustomer', filter: 'formatFloat'},
        {title: '', value: ''},
        {title: 'New Customers who has 1 order', value: 'newCustomer1Order', filter: 'formatFloat', type: 'link'},
        {title: 'New Customers who has > 1 order', value: 'newCustomerMore1Order', filter: 'formatFloat', type: 'link'},
        {title: 'Total Gallons', value: 'totalCustomerGallons', filter: 'formatFloat', _copper:'with N/A'},
        {title: 'New Customers Gallons', value: 'newCustomerGallons', filter: 'formatFloat'},
        {title: 'Recurrent Customers Gallons', value: 'recurrentCustomerGallons', filter: 'formatFloat'},
        {title: '', value: ''},
        {title: 'New Customers Gallons who has 1 order', value: 'newCustomerGallons1Order', filter: 'formatFloat', type: 'link'},
        {title: 'New Customers Gallons who has > 1 order', value: 'newCustomerGallonsMore1Order', filter: 'formatFloat', type: 'link'},
        {title: 'Avg order by all customers', value: 'clients_avg_order', filter: 'formatPrice', _copper:'with N/A'},
        {title: 'Avg order for a customer who has 1 order', value: 'clients_who_have_1_order', filter: 'formatPrice', _copper:'with N/A'},
        {title: 'Avg order for a customer who has > 1 order', value: 'clients_who_more_1_order', filter: 'formatPrice', _copper:'with N/A'},
      ],
      sortBy: 'total_amt',
      sortDesc: true,
      headers: [
        {text: 'FlameHub User Name', value: 'customer_name', class: 'black--text'},
        {text: 'FlameHub Company ', value: 'company_name', class: 'black--text'},
        {text: 'Total Gallons', value: 'total_gallon', class: 'black--text'},
        {text: 'Total Orders', value: 'count', class: 'black--text'},
        {text: 'Total Sale', value: 'total_amt', class: 'black--text'},
      ],
      headersCopper: [
        {text: 'Copper Company', value: 'company_name', class: 'black--text'},
        {text: 'Total Gallons', value: 'total_gallon', class: 'black--text'},
        {text: 'Total Orders', value: 'count', class: 'black--text'},
        {text: 'Total Sale', value: 'total_amt', class: 'black--text'},
      ],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      loaded: false,
      loadedCompare: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem) {
                    return tooltipItem.yLabel;
                }
            }
        }
      },
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      updateDiagram: false
    }
  },
  watch: {
    hoverOnTable() {
      this.showScrollingArrows()
    },
    dateStart() {
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()
    },
    dateEnd() {
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()
    },
    isCompareFilter() {
      if (!this.isCompareFilter) {
        let d = moment(this.dateStart)
        this.dateCompareEnd = new Date(
                                Date.UTC(
                                  new Date(d).getFullYear(),
                                  new Date(d).getMonth(),
                                  new Date(d).getDate() - 1)
                                ).toISOString().substr(0, 10)

        this.dateCompareStart = new Date(
                                  Date.UTC(
                                    new Date(d).getFullYear(),
                                    new Date(d).getMonth(),
                                    new Date(d).getDate() - this.diffDays)
                                  ).toISOString().substr(0, 10)
        this.updateDiagram = true
      } else {
        this.applayCompares()
      }
    },
    isHubFilter(){
      this.filterDataItems()
    },
  },
  created() {
    this.countDiffDayes()
    this.countDateCompareEnd()
    this.countDateCompareStart()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    if (localStorage.getItem('customerReport')) {
      let data = JSON.parse(localStorage.getItem('customerReport'))
      this.dateStart = data.dateStart
      this.dateEnd = data.dateEnd
      this.defaultPeriod = data.defaultPeriod
      localStorage.removeItem('customerReport')
    }

    axios
        .get('/username')
        .then(response => (this.userName = response.data))

    this.applyFilters()
    this.showScrollingArrows()
  },
  methods: {
    applyOrderFilters(){
      this.filterDataItems()
    },
    redirectToSalesReport(key){
      let order_ids = this.data[key+"_ids"]
      order_ids = order_ids.map(function(item) {
          return parseInt(item, 10);
      });

      let orders = JSON.stringify({report: 'customerReport',
                                  order_ids: order_ids,
                                  dateStart: this.dateStart,
                                  dateEnd: this.dateEnd,
                                  defaultPeriod: this.defaultPeriod})
      localStorage.setItem('orders', orders)
      let routeData = this.$router.resolve({ name: 'sales'})
      window.open(routeData.href, '_blank')
    },
    countDiffDayes() {
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(this.dateStart)
      const secondDate = new Date(this.dateEnd)

      this.diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    countDateCompareEnd() {
      let d = moment(this.dateStart)

      this.dateCompareEnd = new Date(
          Date.UTC(
              new Date(d).getFullYear(),
              new Date(d).getMonth(),
              new Date(d).getDate() - 1)
      ).toISOString().substr(0, 10)
    },
    countDateCompareStart() {
      let d = moment(this.dateStart)

      this.dateCompareStart = new Date(
          Date.UTC(
              new Date(d).getFullYear(),
              new Date(d).getMonth(),
              new Date(d).getDate() - this.diffDays)
      ).toISOString().substr(0, 10)
    },
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left')
      const btnRight = document.querySelector('.btn-right')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getCompareDates(dates) {
      this.dateCompareStart = dates.dateStart
      this.dateCompareEnd = dates.dateEnd
      this.applayCompares()
    },
    getDates({ dateStart, dateEnd, compareMode }) {
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.isCompareFilter = compareMode
      this.applyFilters()
    },
    applayCompares() {
      this.loadedCompare = true
      axios
          .get('/dashboard/customers/' + this.dateCompareStart + '/' + this.dateCompareEnd)
          .then(response => {
            this.dataCompare = response.data
            this.dataCompare.clients_who_have_1_order_cmp = this.data.clients_who_have_1_order - this.dataCompare.clients_who_have_1_order
            this.dataCompare.clients_who_more_1_order_cmp = this.data.clients_who_more_1_order - this.dataCompare.clients_who_more_1_order
            this.dataCompare.clients_avg_order_cmp = this.data.clients_avg_order - this.dataCompare.clients_avg_order

            this.dataCompare.totalCustomer_cmp = this.data.totalCustomer - this.dataCompare.totalCustomer
            this.dataCompare.recurrentCustomer_cmp = this.data.recurrentCustomer - this.dataCompare.recurrentCustomer
            this.dataCompare.newCustomer_cmp = this.data.newCustomer - this.dataCompare.newCustomer
            this.dataCompare.totalCustomerGallons_cmp = this.data.totalCustomerGallons - this.dataCompare.totalCustomerGallons
            this.dataCompare.recurrentCustomerGallons_cmp = this.data.recurrentCustomerGallons - this.dataCompare.recurrentCustomerGallons
            this.dataCompare.newCustomerGallons_cmp = this.data.newCustomerGallons - this.dataCompare.newCustomerGallons

            this.dataCompare.newCustomer1Order_cmp = this.data.newCustomer1Order - this.dataCompare.newCustomer1Order
            this.dataCompare.newCustomerMore1Order_cmp = this.data.newCustomerMore1Order - this.dataCompare.newCustomerMore1Order
            this.dataCompare.newCustomerGallons1Order_cmp = this.data.newCustomerGallons1Order - this.dataCompare.newCustomerGallons1Order
            this.dataCompare.newCustomerGallonsMore1Order_cmp = this.data.newCustomerGallonsMore1Order - this.dataCompare.newCustomerGallonsMore1Order

            this.dataCompare.clients_who_have_1_order_copper_cmp = this.data.clients_who_have_1_order_copper - this.dataCompare.clients_who_have_1_order_copper
            this.dataCompare.clients_who_more_1_order_copper_cmp = this.data.clients_who_more_1_order_copper - this.dataCompare.clients_who_more_1_order_copper
            this.dataCompare.clients_avg_order_copper_cmp = this.data.clients_avg_order_copper - this.dataCompare.clients_avg_order_copper

            this.dataCompare.totalCustomer_copper_cmp = this.data.totalCustomer_copper - this.dataCompare.totalCustomer_copper
            this.dataCompare.recurrentCustomer_copper_cmp = this.data.recurrentCustomer_copper - this.dataCompare.recurrentCustomer_copper
            this.dataCompare.newCustomer_copper_cmp = this.data.newCustomer_copper - this.dataCompare.newCustomer_copper
            this.dataCompare.totalCustomerGallons_copper_cmp = this.data.totalCustomerGallons_copper - this.dataCompare.totalCustomerGallons_copper
            this.dataCompare.recurrentCustomerGallons_copper_cmp = this.data.recurrentCustomerGallons_copper - this.dataCompare.recurrentCustomerGallons_copper
            this.dataCompare.newCustomerGallons_copper_cmp = this.data.newCustomerGallons_copper - this.dataCompare.newCustomerGallons_copper

            this.dataCompare.newCustomer1Order_copper_cmp = this.data.newCustomer1Order_copper - this.dataCompare.newCustomer1Order_copper
            this.dataCompare.newCustomerMore1Order_copper_cmp = this.data.newCustomerMore1Order_copper - this.dataCompare.newCustomerMore1Order_copper
            this.dataCompare.newCustomerGallons1Order_copper_cmp = this.data.newCustomerGallons1Order_copper - this.dataCompare.newCustomerGallons1Order_copper
            this.dataCompare.newCustomerGallonsMore1Order_copper_cmp = this.data.newCustomerGallonsMore1Order_copper - this.dataCompare.newCustomerGallonsMore1Order_copper

            this.loadedCompare = false
            this.filterDataItems()
          })
    },
    filterDataItems(){
      if (this.isHubFilter){
        if (this.byOrderFilter === 'All') {
          this.dataItems = this.data.returned_customer_by_date
        }
        if (this.byOrderFilter === '= 1 Order') {
          this.dataItems = this.data.returned_customer_by_date.filter(el => el.count == 1)
        }
        if (this.byOrderFilter === '> 1 Order') {
          this.dataItems = this.data.returned_customer_by_date.filter(el => el.count > 1)
        }
      } else {
        if (this.byOrderFilter === 'All') {
          this.dataItems = this.data.returned_customer_by_date_copper
        }
        if (this.byOrderFilter === '= 1 Order') {
          this.dataItems = this.data.returned_customer_by_date_copper.filter(el => el.count == 1)
        }
        if (this.byOrderFilter === '> 1 Order') {
          this.dataItems = this.data.returned_customer_by_date_copper.filter(el => el.count > 1)
        }
      }
    },
    applyFilters() {
      this.loaded = true
      axios
          .get('/dashboard/customers/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data

            if (!this.isCompareFilter){
              this.dataCompare = {}
            }

            this.dataCompare.clients_who_have_1_order_cmp = this.data.clients_who_have_1_order - this.dataCompare.clients_who_have_1_order
            this.dataCompare.clients_who_more_1_order_cmp = this.data.clients_who_more_1_order - this.dataCompare.clients_who_more_1_order
            this.dataCompare.clients_avg_order_cmp = this.data.clients_avg_order - this.dataCompare.clients_avg_order

            this.dataCompare.totalCustomer_cmp = this.data.totalCustomer - this.dataCompare.totalCustomer
            this.dataCompare.recurrentCustomer_cmp = this.data.recurrentCustomer - this.dataCompare.recurrentCustomer
            this.dataCompare.newCustomer_cmp = this.data.newCustomer - this.dataCompare.newCustomer
            this.dataCompare.totalCustomerGallons_cmp = this.data.totalCustomerGallons - this.dataCompare.totalCustomerGallons
            this.dataCompare.recurrentCustomerGallons_cmp = this.data.recurrentCustomerGallons - this.dataCompare.recurrentCustomerGallons
            this.dataCompare.newCustomerGallons_cmp = this.data.newCustomerGallons - this.dataCompare.newCustomerGallons

            this.dataCompare.newCustomer1Order_cmp = this.data.newCustomer1Order - this.dataCompare.newCustomer1Order
            this.dataCompare.newCustomerMore1Order_cmp = this.data.newCustomerMore1Order - this.dataCompare.newCustomerMore1Order
            this.dataCompare.newCustomerGallons1Order_cmp = this.data.newCustomerGallons1Order - this.dataCompare.newCustomerGallons1Order
            this.dataCompare.newCustomerGallonsMore1Order_cmp = this.data.newCustomerGallonsMore1Order - this.dataCompare.newCustomerGallonsMore1Order

            this.dataCompare.clients_who_have_1_order_copper_cmp = this.data.clients_who_have_1_order_copper - this.dataCompare.clients_who_have_1_order_copper
            this.dataCompare.clients_who_more_1_order_copper_cmp = this.data.clients_who_more_1_order_copper - this.dataCompare.clients_who_more_1_order_copper
            this.dataCompare.clients_avg_order_copper_cmp = this.data.clients_avg_order_copper - this.dataCompare.clients_avg_order_copper

            this.dataCompare.totalCustomer_copper_cmp = this.data.totalCustomer_copper - this.dataCompare.totalCustomer_copper
            this.dataCompare.recurrentCustomer_copper_cmp = this.data.recurrentCustomer_copper - this.dataCompare.recurrentCustomer_copper
            this.dataCompare.newCustomer_copper_cmp = this.data.newCustomer_copper - this.dataCompare.newCustomer_copper
            this.dataCompare.totalCustomerGallons_copper_cmp = this.data.totalCustomerGallons_copper - this.dataCompare.totalCustomerGallons_copper
            this.dataCompare.recurrentCustomerGallons_copper_cmp = this.data.recurrentCustomerGallons_copper - this.dataCompare.recurrentCustomerGallons_copper
            this.dataCompare.newCustomerGallons_copper_cmp = this.data.newCustomerGallons_copper - this.dataCompare.newCustomerGallons_copper

            this.dataCompare.newCustomer1Order_copper_cmp = this.data.newCustomer1Order_copper - this.dataCompare.newCustomer1Order_copper
            this.dataCompare.newCustomerMore1Order_copper_cmp = this.data.newCustomerMore1Order_copper - this.dataCompare.newCustomerMore1Order_copper
            this.dataCompare.newCustomerGallons1Order_copper_cmp = this.data.newCustomerGallons1Order_copper - this.dataCompare.newCustomerGallons1Order_copper
            this.dataCompare.newCustomerGallonsMore1Order_copper_cmp = this.data.newCustomerGallonsMore1Order_copper - this.dataCompare.newCustomerGallonsMore1Order_copper
            this.filterDataItems()
            this.loaded = false
          })
    },
    cleanFilters() {
      this.search = ''
    },
    rowClick(item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
  }
}
</script>

<style scoped>
  .calls-text-card {
    font-size: 1.2em;
    color: black !important;
  }
  .calls-card {
    min-height: 150px;
    padding: 20px 40px;
    width: 32%;
  }
  .calls-card-title {
    font-size: 0.9em;
    color: black !important;
    word-break: keep-all;
  }
  @media (min-width: 960px) and (max-width: 980px) {
    .calls-card-title {
      word-break: break-all;
    }
  }
  @media (max-width: 600px) {
    .calls-card {
      width: 99% !important;
    }
  }
  @media (min-width: 601px) and (max-width: 959px) {
    .calls-card {
      width: 49% !important;
    }
  }
  .calls-card-title {
    word-break: keep-all;
  }
  .compare-text {
    font-size: 0.80em !important;
  }
  .compare-icon {
    font-size: 0.95em !important;
  }
    .calls-card:hover {
    background-color: #3F51B5;
    color: white !important;
  }
  .calls-card:hover .calls-card-title, 
  .calls-card:hover .calls-text-card {
    color: white !important;
  }
    .calls-card:hover .green--text {
    color: #A5D6A7 !important;
  }
  .calls-card:hover .red--text {
    color: #E57373 !important;
  }
</style>
